module.exports = __webpack_public_path__ + "static/img/logo.60242fbc.svg";